export default [
    {
        meta: {
            title: 'Sales',
            permissions: "sales"

        },
        path: '',
        name: 'sales-list',
        component: () => import('@/views/sales/SalesListView.vue')
    },
    {
        meta: {
            title: 'Sales',
            permissions: "sales"

        },
        path: 'by-products',
        name: 'sales-list-by-products',
        component: () => import('@/views/sales/SalesListByProductsView.vue')
    },
    {
        meta: {
            title: 'Sales',
            permissions: "sales"

        },
        path: ':id',
        name: 'sale',
        component: () => import('@/views/sales/SaleView.vue')
    },
]